export interface SalesOrderLineValue {
  description: string;
  value: number;
  productType: string;
  unitOfMeasure: string;
  quantity: number;
  typeValue: number;
}
